import './lifeHackBanner.css';
import lifeHackBanner from './LifeHackBanner';

export default lifeHackBanner;